import { createSelector } from '@reduxjs/toolkit';

import {
  DEFAULT_SQL_QUOTE_CHARACTER,
  DataSourceType,
  DataSourceTypeDescription,
  JDBC_DATA_SOURCE_FAMILY,
  SAMPLE_MUSIC_DATA_SOURCE_TYPE,
  defaultTypeDescription,
} from 'src/constants/dataSourceTypeDescription';
import { SAMPLE_MUSIC_DATA_SOURCE } from 'src/constants/sampleDataSource';
import { dataSourceTypeDescriptionSelector } from 'src/selectors/dataSourceTypeDescription';
import { Connection } from 'src/store/connections/types';

export const dataSourceNativeQuoteCharacter = (
  typeDescription: DataSourceTypeDescription = defaultTypeDescription,
  type: DataSourceType | null
) => {
  if (type === null) {
    return null;
  }
  // For sample music data source, use the underlying MYSQL type
  const actualType =
    type === SAMPLE_MUSIC_DATA_SOURCE_TYPE
      ? SAMPLE_MUSIC_DATA_SOURCE.type
      : type;
  const sourceTypeDescription = typeDescription.DATA_SOURCE_TYPES[actualType];
  if (
    !sourceTypeDescription ||
    sourceTypeDescription.dataSourceFamily !== JDBC_DATA_SOURCE_FAMILY
  ) {
    return null;
  }
  return (
    sourceTypeDescription.identifierQuoteCharacter ||
    DEFAULT_SQL_QUOTE_CHARACTER
  );
};

export const dataSourceNativeQuoteCharacterSelector = (
  type: DataSourceType | null,
  connection: Connection | null
) =>
  createSelector(
    dataSourceTypeDescriptionSelector(connection),
    (typeDescription) => dataSourceNativeQuoteCharacter(typeDescription, type)
  );
